export default "__VITE_ASSET__BE7UEMs4__"